import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-emerald-100 text-emerald-800 shadow hover:bg-emerald-200 hover:text-emerald-900",
        secondary:
          "border-transparent bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900",
        destructive:
          "border-transparent bg-red-100 text-red-800 shadow hover:bg-red-200 hover:text-red-900",
        outline: "text-foreground border-gray-300 hover:bg-gray-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
